import { Suspense, lazy } from 'react';

const EntityAnalyticsPage = lazy(() => import('../components/Analytics/EntityAnalyticsPage'));

const EntityAnalyticsLazy: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <EntityAnalyticsPage />
    </Suspense>
  );
};

export default EntityAnalyticsLazy;
